/** Audience re-evaluation: fixed at upload time vs follows group membership over time. */
export const SCHOOL_DOCUMENT_AUDIENCE_MODE = {
    static: 0,
    dynamic: 1,
};

/** When eligible students are notified about this document. */
export const SCHOOL_DOCUMENT_NOTIFICATION_MODE = {
    none: 0,
    initialOnly: 1,
    initialAndNewEligible: 2,
};

/** Who the document is assigned to (student vs employee profiles). */
export const SCHOOL_DOCUMENT_ASSIGNMENT_TYPE = {
    students: 1,
    employees: 2,
};

export const DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE = SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic;
export const DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE = SCHOOL_DOCUMENT_NOTIFICATION_MODE.none;
export const DEFAULT_SCHOOL_DOCUMENT_ASSIGNMENT_TYPE = SCHOOL_DOCUMENT_ASSIGNMENT_TYPE.students;

const AUDIENCE_MODE_LABELS = {
    [SCHOOL_DOCUMENT_AUDIENCE_MODE.static]: 'Fixed when saved',
    [SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic]: 'Keeps up with groups',
};

const NOTIFICATION_MODE_LABELS = {
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.none]: 'No notifications',
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.initialOnly]: 'Once, when it first applies',
    [SCHOOL_DOCUMENT_NOTIFICATION_MODE.initialAndNewEligible]: 'First applies and new eligible',
};

const ASSIGNMENT_TYPE_LABELS = {
    [SCHOOL_DOCUMENT_ASSIGNMENT_TYPE.students]: 'Students',
    [SCHOOL_DOCUMENT_ASSIGNMENT_TYPE.employees]: 'Employees',
};

export function formatSchoolDocumentAudienceMode(mode) {
    const n = mode == null ? DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE : Number(mode);
    return AUDIENCE_MODE_LABELS[n] ?? String(mode);
}

export function formatSchoolDocumentNotificationMode(mode) {
    const n = mode == null ? DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE : Number(mode);
    return NOTIFICATION_MODE_LABELS[n] ?? String(mode);
}

export function formatSchoolDocumentAssignmentType(type) {
    const n = type == null ? DEFAULT_SCHOOL_DOCUMENT_ASSIGNMENT_TYPE : Number(type);
    return ASSIGNMENT_TYPE_LABELS[n] ?? String(type);
}

export function normalizeSchoolDocumentAudienceMode(mode) {
    if (mode == null || mode === '') return DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE;
    const n = Number(mode);
    return n === SCHOOL_DOCUMENT_AUDIENCE_MODE.static || n === SCHOOL_DOCUMENT_AUDIENCE_MODE.dynamic
        ? n
        : DEFAULT_SCHOOL_DOCUMENT_AUDIENCE_MODE;
}

export function normalizeSchoolDocumentNotificationMode(mode) {
    if (mode == null || mode === '') return DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE;
    const n = Number(mode);
    return n in NOTIFICATION_MODE_LABELS
        ? n
        : DEFAULT_SCHOOL_DOCUMENT_NOTIFICATION_MODE;
}

export function normalizeSchoolDocumentAssignmentType(type) {
    if (type == null || type === '') return DEFAULT_SCHOOL_DOCUMENT_ASSIGNMENT_TYPE;
    const n = Number(type);
    return n === SCHOOL_DOCUMENT_ASSIGNMENT_TYPE.students || n === SCHOOL_DOCUMENT_ASSIGNMENT_TYPE.employees
        ? n
        : DEFAULT_SCHOOL_DOCUMENT_ASSIGNMENT_TYPE;
}
